import styled from "styled-components";

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`; 

export const  Columns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;

  & > div {
    width: 100%;
  }
`; 

export const Count = styled.span`
  margin-left: 5px;
  color: ${(props) => props.theme.colors.davysGrey};
  font-weight: 300;
`;

export const CustomTag = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;

export const CustomTagLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  font-size: 12px;
`;

export const CustomTagRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  font-size: 12px;
`;

export const ErrorWrapper = styled.div`
  padding: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const EmptyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  padding: 24px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.white};
  margin: 0 auto;
`;